import React from "react";

//#region src/icons/SparklesIcon.tsx
function SparklesIcon({ className = "" }) {
	return /* @__PURE__ */ React.createElement("svg", {
		width: "20",
		height: "20",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "1.3",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		className: `DocSearch-Hit-icon-sparkles ${className}`,
		"aria-hidden": "true"
	}, /* @__PURE__ */ React.createElement("path", { d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" }), /* @__PURE__ */ React.createElement("path", { d: "M20 3v4" }), /* @__PURE__ */ React.createElement("path", { d: "M22 5h-4" }), /* @__PURE__ */ React.createElement("path", { d: "M4 17v2" }), /* @__PURE__ */ React.createElement("path", { d: "M5 18H3" }));
}

//#endregion
export { SparklesIcon as t };
//# sourceMappingURL=SparklesIcon-D0XWamV3.js.map